import React from 'react';
import styled from 'styled-components';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import numeral from 'numeral';

export default function Budget({ data }) {
  if (!data) {
    return null;
  }

  const { budget = [] } = data;

  return (
    <Container>
      <OuterTable>
        <Heading>
          <h2>Budget</h2>
        </Heading>
        <TableContainer>
          <Table>
            <StyledTableHead>
              <TableRow>
                <TableCell align="center">Expenses</TableCell>
                <TableCell align="left">Current Forecast</TableCell>
                <TableCell align="center">Variance</TableCell>
                <TableCell align="center">Notes</TableCell>
              </TableRow>
            </StyledTableHead>
            <TableBody>
              {budget.filter(
                row => parseInt(row?.notes) !== 0 || parseInt(row?.current) !== 0
              ).map(({ expenses, current = 0, variance, notes }, index) => (
                <StyleTableRow>
                  <StyledTableCell align="left" bold>{expenses}</StyledTableCell>
                  <StyledTableCell align="left" bold={index === budget.length - 1}>${numeral(current).format(0, 0)}</StyledTableCell>
                  <StyledTableCell align="left" bold={index === budget.length - 1}><Variance data={variance}/></StyledTableCell>
                  <StyledTableCell align="left" bold={index === budget.length - 1}>{notes}</StyledTableCell>
                </StyleTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </OuterTable>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const OuterTable = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;
  background-color: #FFFFFF;
  border: solid 1px #ccd7e3;
  border-radius: 4px;
  padding-bottom: 20px; 
`;

const Heading = styled.div`
  padding: 20px;
  padding-bottom: 0px;
  h2 {
    color: #595959;
    font-size: 24px;
    font-weight: 700;
  }
`;

const StyleTableRow = styled(TableRow)`
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #f5f8fa;
  border-top: solid 1px #ccd7e3;
  border-bottom: solid 1px #ccd7e3;
  display: flex;
  flex-direction: row;
  div:nth-child(1) {
    flex: 1;
  }
  div:nth-child(2) {
    flex: 1;
  }
`;

const StyledTableHead = styled(TableHead)`
  th {
    font-size: 16px !important;
    font-weight: bold !important;
    text-align: left !important;
    color: #595959 !important;
    white-space: nowrap;
  }
`;

const StyledTableCell = styled(TableCell)`
  font-size: 16px !important;
  ${({ bold }) => bold && 'font-weight: bold !important;'}
`;

const P = styled.div``;

const Sub = styled.span`
  font-size: 0.8em;
  font-weight: bold;
`;

const VarianceValue = styled.div`
  width: 72px;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
  font-size: 14px;
  text-align: center;
  ${({ negative }) => negative
    ? 'color: #AF0000; background-color: rgba(242, 84, 91, 0.24);'
    : 'color: #005F40; background-color: rgba(98, 198, 96, 0.32);'}

`;
function Variance({ data }) {
  const value = Math.round(parseFloat(data) * 10) / 10;

  return <VarianceValue negative={value < 0}>{value}%</VarianceValue>;
}